var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSketch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.36406 1.61467L10 1.02295L15.6359 1.61482L20 7.42451L10 18.977L0 7.42451L4.36406 1.61467Z",
    fill: "#FDB300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.05078 7.42456L10 18.9771L0 7.42456H4.05078ZM15.9492 7.42456L10 18.9771L20 7.42456H15.9492Z",
    fill: "#EA6C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.05078 7.42456H15.9492L10 18.9771L4.05078 7.42456Z",
    fill: "#FDAD00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.02295L4.36406 1.61467L4.05078 7.42451L10 1.02295ZM10 1.02295L15.6359 1.61467L15.9492 7.42451L10 1.02295Z",
    fill: "#FDD231"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 7.42453L15.636 1.61469L15.9493 7.42453H20Z",
    fill: "#FDAD00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.02295L4.05078 7.42451H15.9492L10 1.02295Z",
    fill: "#FEEEB7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.42453L4.36406 1.61469L4.05078 7.42453H0Z",
    fill: "#FDAD00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSketch);
export default __webpack_public_path__ + "static/media/sketch.c9485e9cdb4e9708ae4498e6becf436f.svg";
export { ForwardRef as ReactComponent };